var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.02209 0.5L23.0173 0.521131L22.9952 23.5L1.00002 23.4789L1.02209 0.5Z",
    fill: "white",
    fillOpacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.88476 22.5231C2.3505 22.5226 1.91782 22.0672 1.91836 21.506L1.93665 2.47446C1.93718 1.91322 2.37073 1.45867 2.905 1.45918L21.1325 1.47669C21.6667 1.47721 22.0994 1.93259 22.0989 2.49383L22.0806 21.5254C22.0801 22.0866 21.6465 22.5412 21.1122 22.5407C20.4673 22.54 14.3915 22.5342 2.88476 22.5231Z",
    stroke: "#7E74F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7298 9.07987L16.7346 9.07795L16.4988 9.07773C15.8802 9.07713 15.3782 9.60057 15.3776 10.2468L15.3753 12.588L18.7264 12.5912L18.2322 16.1002L15.372 16.0975L15.3658 22.5351L11.6807 22.5315L11.6869 16.0939L8.64429 16.091L8.64766 12.5815L11.6509 12.5844L11.6934 9.2533L11.6836 8.05935C11.6697 6.3734 12.9667 4.99484 14.5804 4.9802C14.5898 4.98012 14.5991 4.98008 14.6085 4.98008L18.7337 4.98405L18.7298 9.07987Z",
    fill: "#7E74F1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceIcon);
export default __webpack_public_path__ + "static/media/face-icon.569a22a0de3bc9cb882937a9b814d8a6.svg";
export { ForwardRef as ReactComponent };